import { DeleteModal } from "./DeleteModal";
import { AddModal } from "./AddModal";
import { EditModal } from "./EditModal";
import { QualsSelectedTableData } from "./QualsSelectedTableData";
import { QualsAvaibleTableData } from "./QualsAvaibleTableData";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    getAllQualifications,
    setQualificationToSelected,
    setQualificationToDeselected,
    setSnackbarState,
    setQualSelectedTablePage,
    setQualAvailableTablePage,
    setQualAvailableTableRow,
    setQualSelectedTableRow,
    setQualEditModalInfo,
    postQualificationUpdateInfo,
    getQualificationCategories,
    setQualsAvailableSelectedCategory,
    setAddModalInfo,
    getAllUsers,
    getRequiredQualifications,
    postRequiredQualification,
    postUpdatedUser,
    setDeleteModalInfo,
    deleteQualificationFromRequiredQualifications,
    deleteQualificationFromUsers,
    setQualsSelectedSelectedCategory
} from "./actions";
import {
    selectSelectedQualifications,
    selectUnselectedQualifications,
    selectPostSuccess,
    selectPostFail,
    selectQualSelectedTablePage,
    selectQualAvailableTablePage,
    selectQualAvailableTableRow,
    selectQualSelectedTableRow,
    selectQualEditModalInfo,
    selectQualCategories,
    selectQualsAvailableSelectedCategory,
    selectQualAddModalInfo,
    selectAllUsers,
    selectRequiredQualifications,
    selectDeleteModalInfo,
    selectPostingQualifications,
    selectQualsSelectedSelectedCategory
} from "./selectors";
import { Typography, Snackbar, SnackbarContent, Paper, withStyles } from "@material-ui/core";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";

const styles = () => ({
    table: {
        marginTop: " 20px",
        marginBottom: "20px",
        padding: "15px"
    },
    tableCell: {
        padding: "5px"
    },
    formControl: {
        width: "35%",
        margin: "15px"
    },
    titlePaper: {
        width: "fit-content",
        marginBottom: "25px",
        padding: "20px",
        border: "1px solid black"
    }
});

class QualificationsManager extends Component {
    constructor(props) {
        super(props);
        props.getAllQualifications();
        props.getQualificationCategories();
        props.getAllUsers();
        props.getRequiredQualifications();
        this.state = {
            qualEditModalInfo: {
                qualID: "",
                qualTitle: "",
                qualExpReq: "",
                qualImgReq: "",
                qualRegReq: "",
                qualVerReq: ""
            }
        };
    }
    render() {
        const { classes } = this.props;
        let selectedQualifications =
            this.props.selectedQualifications === false ? false : this.props.selectedQualifications;
        let unselectedQualifications =
            this.props.unselectedQualifications === false
                ? false
                : this.props.unselectedQualifications;
        return (
            <div>
                <Paper className={classes.titlePaper}>
                    <Typography variant="display2"> Qualifications Manager </Typography>
                </Paper>

                <QualsSelectedTableData
                    rowsPerPageQualsTable2={this.props.qualSelectedTableRow}
                    pageQualsTable2={this.props.qualSelectedTablePage}
                    TablePaginationHelper={TablePaginationHelper}
                    selectedQualifications={selectedQualifications}
                    setState={this.setState}
                    classes={classes}
                    setQualSelectedTablePage={this.props.setQualSelectedTablePage}
                    setQualSelectedTableRow={this.props.setQualSelectedTableRow}
                    setQualEditModalInfo={this.props.setQualEditModalInfo}
                    qualCategories={this.props.qualCategories}
                    setDeleteModalInfo={this.props.setDeleteModalInfo}
                    selectedCategory={this.props.qualSelectedSelectedCategory}
                    setCategory={this.props.setQualsSelectedSelectedCategory}
                />
                <QualsAvaibleTableData
                    rowsPerPageQualsTable1={this.props.qualAvailableTableRow}
                    pageQualsTable1={this.props.qualAvailableTablePage}
                    TablePaginationHelper={TablePaginationHelper}
                    unselectedQualifications={unselectedQualifications}
                    setQualificationToSelected={this.props.setQualificationToSelected}
                    setState={this.setState}
                    classes={classes}
                    setQualAvailableTablePage={this.props.setQualAvailableTablePage}
                    setQualAvailableTableRow={this.props.setQualAvailableTableRow}
                    setQualEditModalInfo={this.props.setQualEditModalInfo}
                    qualCategories={this.props.qualCategories}
                    selectedCategory={this.props.qualAvailableSelectedCategory}
                    setCategory={this.props.setQualsAvailableSelectedCategory}
                    addModalInfo={this.props.setAddModalInfo}
                />
                <EditModal
                    qualEditModalInfo={this.props.qualEditModalInfo}
                    setQualEditModalInfo={this.props.setQualEditModalInfo}
                    setState={this.setState}
                    classes={classes}
                    postQualificationUpdateInfo={this.props.postQualificationUpdateInfo}
                />
                <AddModal
                    qualAddModalInfo={this.props.qualAddModalInfo}
                    addModalInfo={this.props.setAddModalInfo}
                    setQualificationToSelected={this.props.setQualificationToSelected}
                    requiredQualifications={this.props.requiredQualifications}
                    postRequiredQualification={this.props.postRequiredQualification}
                    unselectedQualifications={this.props.unselectedQualifications}
                    allUsers={this.props.allUsers}
                    postUpdatedUser={this.props.postUpdatedUser}
                />
                <DeleteModal
                    deleteModalInfo={this.props.deleteModalInfo}
                    setDeleteModalInfo={this.props.setDeleteModalInfo}
                    setQualificationToDeselected={this.props.setQualificationToDeselected}
                    deleteQualificationFromRequiredQualifications={
                        this.props.deleteQualificationFromRequiredQualifications
                    }
                    deleteQualificationFromUsers={this.props.deleteQualificationFromUsers}
                    allUsers={this.props.allUsers}
                    getRequiredQualifications={this.props.getRequiredQualifications}
                    posting={this.props.posting}
                />

                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    autoHideDuration={6000}
                    open={this.props.postSuccess}
                    onClose={() => {
                        this.props.setSnackbarState(false);
                    }}
                >
                    <SnackbarContent
                        style={{ backgroundColor: "green", color: "white" }}
                        message={"Qualification Successfully Updated"}
                    />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    autoHideDuration={6000}
                    open={this.props.postFail}
                    onClose={() => {
                        this.props.setSnackbarState(false);
                    }}
                >
                    <SnackbarContent
                        style={{ backgroundColor: "red", color: "white" }}
                        message={"Unable To Update Qualification, Please Contact Admin"}
                    />
                </Snackbar>
            </div>
        );
    }
}
export default connect(
    store => {
        return {
            selectedQualifications: selectSelectedQualifications(store),
            unselectedQualifications: selectUnselectedQualifications(store),
            postSuccess: selectPostSuccess(store),
            postFail: selectPostFail(store),
            qualSelectedTablePage: selectQualSelectedTablePage(store),
            qualAvailableTablePage: selectQualAvailableTablePage(store),
            qualAvailableTableRow: selectQualAvailableTableRow(store),
            qualSelectedTableRow: selectQualSelectedTableRow(store),
            qualEditModalInfo: selectQualEditModalInfo(store),
            qualCategories: selectQualCategories(store),
            qualAvailableSelectedCategory: selectQualsAvailableSelectedCategory(store),
            qualAddModalInfo: selectQualAddModalInfo(store),
            allUsers: selectAllUsers(store),
            requiredQualifications: selectRequiredQualifications(store),
            deleteModalInfo: selectDeleteModalInfo(store),
            posting: selectPostingQualifications(store),
            qualSelectedSelectedCategory: selectQualsSelectedSelectedCategory(store)
        };
    },
    {
        getAllQualifications,
        setQualificationToSelected,
        setQualificationToDeselected,
        setSnackbarState,
        setQualSelectedTablePage,
        setQualAvailableTablePage,
        setQualAvailableTableRow,
        setQualSelectedTableRow,
        setQualEditModalInfo,
        postQualificationUpdateInfo,
        getQualificationCategories,
        setQualsAvailableSelectedCategory,
        setAddModalInfo,
        getAllUsers,
        getRequiredQualifications,
        postRequiredQualification,
        postUpdatedUser,
        setDeleteModalInfo,
        deleteQualificationFromRequiredQualifications,
        deleteQualificationFromUsers,
        setQualsSelectedSelectedCategory
    }
)(withStyles(styles)(QualificationsManager));
